/// <reference types="./getTotalCount.d.ts" />
import { ok, } from '@dossierhq/core';
import { queryOne } from '../QueryFunctions.js';
import { totalAdminEntitiesQuery } from '../search/QueryGenerator.js';
export async function adminEntitySearchTotalCount(database, schema, context, query, resolvedAuthKeys) {
    const sqlQuery = totalAdminEntitiesQuery(schema, resolvedAuthKeys, query);
    if (sqlQuery.isError()) {
        return sqlQuery;
    }
    const result = await queryOne(database, context, sqlQuery.value);
    if (result.isError()) {
        return result;
    }
    return ok(result.value.count);
}
//# sourceMappingURL=getTotalCount.js.map